import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../../services/streams.service";
import {StreamProject} from "../../../interfaces";
 
import {domain, protocol} from '../../../config';


///getToken 
//streaming

@Component({
  selector: 'app-stream-settings-protection',
  templateUrl: './stream-settings-protection.component.html',
  styleUrls: ['./stream-settings-protection.component.scss'],
})
export class StreamSettingsProtectionComponent implements OnInit, OnDestroy{


   
  @Input() stream: StreamProject

 
  domain: any = {
    name: domain, protocol
  }

   constructor(
    public streamsService: StreamsService   ){

  }
 

  ngOnInit() { 
    
  }

  
   ngOnDestroy() { 
    
   }
 
   
  
}
